import dayjs from 'dayjs';
import GradationalSalary from './GradationalSalary.js';
import User from './User';
import SalaryAllowance from './SalaryAllowance';
import AllowanceStatus from '../enums/AllowanceStatus';

export default class Salary {
  constructor(data) {
    this.id = data?.id;
    this.organizationId = data?.organizationId;
    this.userId = data?.userId;
    this.gradationalSalaryId = data?.gradationalSalaryId;
    this.currentSalary = data?.currentSalary ? Number(data.currentSalary) : null;
    this.adjustment = data?.adjustment ? Number(data.adjustment) : 0;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.user = data?.user ? new User(data?.user) : null;
    this.gradationalSalary = data?.gradationalSalary ? new GradationalSalary(data?.gradationalSalary) : null;

    this.salaryAllowances = data?.salaryAllowances?.map(s => new SalaryAllowance(s));

    this.totalAllowance = data.salaryAllowances ? this.salaryAllowances.filter(a => a.allowance.status.is(AllowanceStatus.ACTIVE)).reduce((sum, allowance) => sum + allowance.amount, 0) : 0;
    this.adjustedSalary = data?.currentSalary ? Number((this.gradationalSalary?.salary ?? 0) + this.adjustment + this.totalAllowance) : null;
  }
}
